import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { LayoutComponent } from '../components/layout/layout.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { SideBarComponent } from './side-bar/side-bar.component';
import { UserManagementModule } from '../user-management/user-management.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from '../_services/token-interceptor.service';
import { ConfirmModalComponent } from '../components/confirm-modal/confirm-modal.component';
import { MessagesModule } from '../messages/messages.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import { ColorPickerModule } from 'ngx-color-picker';
// import { AgmCoreModule } from '@agm/core';
import { ProfileComponent } from '../components/profile/profile.component';
import { QrModalComponent } from '../components/qr-modal/qr-modal.component';
import { BusesModule } from '../buses/buses.module';
import { SharedModule } from '../shared/shared.module';
import { SchoolManagementModule } from '../school-management/school-management.module';
import { CallingScreenModule } from '../calling-screen/calling-screen.module';
import { ReportsModule } from '../reports/reports.module';
import { environment } from 'src/environments/environment';
import { QrStudentModalComponent } from '../components/qr-student-modal/qr-student-modal.component';
import { ListboxModule } from 'primeng/listbox';
import { DropdownModule } from 'primeng/dropdown';
import { QrRevampComponent } from '../components/qr-revamp/qr-revamp.component';
import {MultiSelectModule} from 'primeng/multiselect';
import { OtpInterceptor } from '../_services/otp-interceptor.service';
import { HamburgerNavComponent } from './hamburger-nav/hamburger-nav.component';
import { ProcessingModalComponent } from '../components/processing-modal/processing-modal.component';
import { PermissionsModule } from '../shared/permissions/permissions.module';



@NgModule({
  declarations: [
    QrModalComponent,
    LayoutComponent,
    SideBarComponent,
    ConfirmModalComponent,
    ProfileComponent,
    QrStudentModalComponent,
    QrRevampComponent,
    HamburgerNavComponent,
    ProcessingModalComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    UserManagementModule,
    MessagesModule,
    BusesModule,
    SchoolManagementModule,
    CallingScreenModule,
    ReportsModule,
    MatMenuModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ColorPickerModule,
    MatInputModule,
    MatCheckboxModule,
    ListboxModule,
    DropdownModule,
    MultiSelectModule,
    PermissionsModule,
    // AgmCoreModule.forRoot({
    //   // apiKey: 'AIzaSyDscQPjxngryXG3CzHqg15f2dAz0aSyjTU',
    //   // apiKey: 'AIzaSyDqjIdjtHmnHvvjcRFloSGi6eqdl1tRGFw',
    //   apiKey: environment.googleKey,
    //   libraries: ["places"]
    // }),
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, 
      useClass: OtpInterceptor, 
      multi: true 
    }
  ],
})
export class DashboardModule { }
